import { useState } from 'react';
import style from './Menu.module.css';
import icons from '../../../../img/icons/icons';
import { ButtonActionMini } from '../../buttons/actionMini/ButtonActionMini';
import { ItemMenu } from './ItemMenu';
import { Sidebar } from './Sidebar';

export const Menu = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const clickHome = () => window.location.href = '/';
    const clickCursos = () => window.location.href = '/cursos';
    const clickSobre = () => window.location.href = '/sobre';
    const clickCertificado = () => window.location.href = '/certificado';
    const clickGraduacao = () => window.open('https://www.cruzeirodosulvirtual.com.br/polo/palmeira-das-missoes-centro-rs/?tipo-de-curso=Gradua%C3%A7%C3%A3o%21&ancora=CursosPolo', '_blank');
    const clickPosGraduacao = () => window.open('https://www.cruzeirodosulvirtual.com.br/polo/palmeira-das-missoes-centro-rs/?tipo-de-curso=P%C3%B3s-gradua%C3%A7%C3%A3o%21&ancora=CursosPolo', '_blank');

    return (
        <div className={style.Content}>
            <div className={style.ButtonMenu}>
                <ButtonActionMini icon={icons.Menu} click={() => setIsSidebarOpen(true)} />
            </div>            
            <div className={style.DesktopOnly}>
                <ItemMenu click={clickHome} nome="Home" />
                <ItemMenu click={clickCursos} nome="Cursos" />
                <ItemMenu click={clickGraduacao} nome="Graduação" />
                <ItemMenu click={clickPosGraduacao} nome="Pós-Graduação" />
                <ItemMenu click={clickCertificado} nome="Certificado" />
                <ItemMenu click={clickSobre} nome="Sobre" />
            </div>

            <Sidebar 
                isOpen={isSidebarOpen} 
                onClose={() => setIsSidebarOpen(false)}
                clickHome={clickHome}
                clickCursos={clickCursos}
                clickGraduacao={clickGraduacao}
                clickPosGraduacao={clickPosGraduacao}
                clickCertificado={clickCertificado}
                clickSobre={clickSobre}
            />
        </div>
    );
}